import { render, staticRenderFns } from "./AboutDetails.vue?vue&type=template&id=111931a6&scoped=true&"
import script from "./AboutDetails.vue?vue&type=script&lang=js&"
export * from "./AboutDetails.vue?vue&type=script&lang=js&"
import style0 from "./AboutDetails.vue?vue&type=style&index=0&id=111931a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111931a6",
  null
  
)

export default component.exports